import styled from 'styled-components';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

function ReportModal({ isOpen, onClose, onConfirm }: Props) {
  const totalPassCount = 120;
  const remainingPassCount = 1;
  return (
    <ModalOverlay
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
    >
      <ModalContainer
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <TitleBox>
          <Title>
            새 리포트 열람 시,
            <br />
            퀀트 이용권 1개가 차감됩니다.
          </Title>
          <Description>현재 보유 이용권 {totalPassCount}</Description>
        </TitleBox>

        <RemainCountBox>
          <ReaminCountTitle>잔여 이용권</ReaminCountTitle>
          <Count>
            {remainingPassCount} <span>/{totalPassCount}</span>
          </Count>
        </RemainCountBox>

        <ButtonBox>
          <ResetButton onClick={onClose}>취소</ResetButton>
          <ConfirmButton onClick={onConfirm}>이용권 사용</ConfirmButton>
        </ButtonBox>
      </ModalContainer>
    </ModalOverlay>
  );
}

export default ReportModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  width: 328px;
  background-color: #ffffff;
  border-radius: 16px;
  padding: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;

const Description = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #37383c9c;
`;

const RemainCountBox = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid #008aff;
  background-color: #f7f8fc;
`;

const ReaminCountTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
`;
const Count = styled.p`
  margin: 0;
  font-weight: 700;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;

  span {
    font-family: Spoqa Han Sans Neo;
    font-weight: 500;
    font-size: 12px;
    line-height: 145%;
    letter-spacing: -2%;
    text-align: center;
    color: #37383c9c;
  }
`;

const ButtonBox = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 8px;
`;

const ResetButton = styled.button`
  width: 100%;
  border-radius: 8px;
  padding: 14px 28px;
  background-color: #70737c14;
  border: none;
  cursor: pointer;

  font-weight: 700;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #616161;
`;

const ConfirmButton = styled.button`
  width: 100%;
  border-radius: 8px;
  padding: 14px 28px;
  background-color: #008aff;
  border: none;
  cursor: pointer;

  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #ffffff;
`;
